/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "d192e11db3d620dee91cf168eecb69ca04ea7c2e";
